'use client'

import { AlertCircle, CheckCircle, Loader2 } from 'lucide-react'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'

interface PasswordResetAlertsProps {
  successMessage: string | null
  errorMessage: string | null
  isInitializing: boolean
}

export function PasswordResetAlerts({ successMessage, errorMessage, isInitializing }: PasswordResetAlertsProps) {
  return (
    <div className="space-y-4">
      {successMessage && (
        <Alert className="border-green-200 bg-green-50 text-green-800">
          <CheckCircle className="h-4 w-4 text-green-600" />
          <AlertTitle className="text-green-800">Success</AlertTitle>
          <AlertDescription className="text-green-700">{successMessage}</AlertDescription>
        </Alert>
      )}

      {errorMessage && (
        <Alert variant="destructive" className="border-red-200 bg-red-50 text-red-800">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>{errorMessage}</AlertDescription>
        </Alert>
      )}

      {isInitializing && (
        <Alert className="border-blue-200 bg-blue-50 text-blue-800">
          <Loader2 className="h-4 w-4 animate-spin text-blue-600" />
          <AlertTitle className="text-blue-800">Initializing</AlertTitle>
          <AlertDescription className="text-blue-700">Setting up password reset...</AlertDescription>
        </Alert>
      )}
    </div>
  )
}
